/** @format */

import React, { useState, useEffect, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { clear } from 'services/overlay/actions'
import { overlaySelectors } from 'services/globalSelectors'

import { Login, Registration, Forgot } from '../../views'
import { SocialMedia } from '../index'
import styles from './signUserForms.module.css'

export const Form = memo(() => {
  const dispatch = useDispatch()

  const [page, setPage] = useState('login')
  const errorMessage = useSelector(overlaySelectors.errorMessage)

  useEffect(() => {
    if (errorMessage) dispatch(clear.errorMessages())
  }, [errorMessage, dispatch])

  const render = () => {
    switch (page) {
      case 'registration':
        return <Registration setPage={setPage} />
      case 'forgot':
        return <Forgot setPage={setPage} />
      default:
        return <Login setPage={setPage} />
    }
  }

  return (
    <form className={styles.wrapper}>
      {render()}
      <SocialMedia />
    </form>
  )
})
